import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

import type { DevelopersTableResult } from "./types";

export const isDevelopersTableResult = objectOf<DevelopersTableResult>({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      email: string,
      full_name: string,
      two_factor_auth_enabled: boolean,
      is_suspended: boolean,
      last_signed_in_at: number,
      is_company_admin: boolean,
      app_group_membership_count: number,
      provisioning_method: anyOf(number, nullOrUndefined),
      permissions: arrayOf(
        objectOf({
          scope: number,
          name: number,
          scope_id: string,
        })
      ),
    })
  ),
});
